import { usePartialUpdateCompetitionTeamMutation } from '../mutations';
import { CompetitionTeamForm } from '../create/components/team-form';
import { Schema } from '../create/components/team-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useCompetitionTeamQuery } from '../queries';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { idParamSchema, teamIdParamSchema } from '~/schemas';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export const Page = withPrivateRoute(() => {
  const { id } = useParams(idParamSchema.parse);
  const { teamId } = useParams(teamIdParamSchema.parse);
  const { data } = useCompetitionTeamQuery(teamId);
  const mutation = usePartialUpdateCompetitionTeamMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(
      mutation.mutateAsync({
        id: teamId,
        payload: {
          name: payload.name,
          club: payload.club?.[1] ?? null,
        },
      }),
      {
        success: 'Laget har uppdaterats',
        pending: 'Uppdaterar laget...',
      }
    );
    navigate(-1);
  }

  if (!data) return false;

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera lag" />

      <PageLayout.Section>
        <CompetitionTeamForm
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
          mode="edit"
          competitionId={id}
          defaultValues={{
            division: data.division.id,
            name: data.name,
            club: data.club ? [data.club.name, data.club.id] : null,
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
